<template>
<div>
    <div class="container">
        <div class="columns">
            <div class="column is-10 is-offset-1 m-top-30 m-bottom-50">
                <div class="content-box">
                    <h1 class="content-title has-text-centered">How to schedule DigitalOcean Daily Backups</h1>
                    <div class="content-subtitle"></div>
                    <div class="content-body fs-14">
                        <p>
                            <b>Weap.io</b> allows you to schedule daily DigitalOcean backup snapshots for your Droplets and Volumes. Since the native DigitalOcean snapshots are used, spinning up a new Droplet or restoring an existing one from a daily backup is a breeze.
                        </p>
                    </div>
                    <h2 class="content-subtitle">Why daily backups?</h2>
                    <div class="content-body">
                        <p>
                            Having backups is crucial. Every application that has dynamic content should be backed-up at least once per day for obvious reasons.
                            Keep reading further if you want to schedule DigitalOcean Daily Backups using Weap.
                        </p>
                    </div>
                    <h2 class="content-subtitle">Scheduling Daily Backups</h2>
                    <div class="content-body fs-14">
                        <p>
                            Select the Cloudlet you want to backup every day and open the Frequency and Retention settings. As a first thing, we are going to set the <b>Frequency</b> to <b>Daily</b>.
                        </p>
                        <p style="margin-top:13px;">
                            If you have a special time when the backups should be created, select it. By default, the backups will be created at midnight.
                        </p>
                        <div style="width: 100%;text-align:center; margin-top: 20px;">
                            <img style="border: 2px solid #f1f3f5; border-radius: 6px; box-shadow:0 4px 2px -2px #e6e6e6" width="800px" alt="digital-ocean-daily-backups-frequency" src="/useful/daily-backups-frequency.png">
                        </div>
                    </div>
                    <h2 class="content-subtitle">Retaining the Backups</h2>
                    <div class="content-body fs-14">
                        <p>
                            Now it's time to decide for how long we want to retain the backups. In this example, we are going to retain
                            the <b>last 30 daily backups</b>, the <b>last 4 weekly backups</b>, and the <b>last 3 monthly</b> backups.
                        </p>

                        <div class="notification is-info" style="margin-top:13px; font-size: 13px;">
                            <p>
                                <b>Remember!</b> If your Cloudlet is a Volume, DigitalOcean will not allow more than 25 active snapshots. This means that you should configure the retention policy to retain no more than 25 backups.
                            </p>
                        </div>

                        <div style="width: 100%;text-align:center; margin-top: 20px;">
                            <img style="border: 2px solid #f1f3f5; border-radius: 6px; box-shadow:0 4px 2px -2px #e6e6e6" width="800px" alt="digital-ocean-daily-backups-retention" src="/useful/daily-backups-retention.png">
                        </div>
                    </div>
                    <h2 class="content-subtitle">Conclusion</h2>
                    <div class="content-body fs-14">
                        <p>
                            Congratulations! From now on, your Cloudlet will be backed-up by Weap every day at the selected time. As an extra layer of security, we recommend replicating your backups in multiple DigitalOcean regions, at no extra cost.
                        </p>
                    </div>
                    <!-- <div class="content-body">
                        <p>
                            Congratulations! Now your Cloudlet will be backed-up by Weap every hour. If you need less frequent backups, check out our DigitalOcean Daily Backups guide.
                        </p>
                        <p style="margin-top:13px;">
                            As an extra layer of security, we recommend to replicate your backups in multiple DigitalOcean regions, at no extra cost. Have a look here at our DigitalOcean Region Replication guide for more info.
                        </p>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    metaInfo: {
        title: 'DigitalOcean Daily Backups - Weap.io',
        meta: [
            { name: 'description', content: 'Learn how to automatically create DigitalOcean Daily Backups using Weap.io' },
        ],
    },
}
</script>
